import BaseStore from 'fluxible/addons/BaseStore';
import Actions from '../constants/Actions';

class ProductentityStore extends BaseStore {
  constructor(dispatcher) {
    super(dispatcher);
    this.products = [];
  }

  handleLoadSuccess(products) {
    this.products = products;
    this.emitChange();
  }

  get() {
    return this.products;
  }

  dehydrate() {
    return {
      products: this.products
    };
  }

  rehydrate(state) {
    this.products = state.products;
  }
}

ProductentityStore.storeName = 'ProductentityStore';
ProductentityStore.handlers = {
  [Actions.LOAD_ENTITYPRODUCT_SUCCESS]: 'handleLoadSuccess'
};

export default ProductentityStore;


// WEBPACK FOOTER //
// ./src/stores/ProductentityStore.js